import { Dialog } from '@cimplico/components';
import { useDispatch } from 'react-redux';
import { toastNotification } from '../../../../components/toast/Toast';
import { useResetWorksheetCalculation } from '../../../../queries/use-reset-worksheet-calculation';
import { loadSchema } from '../store/slice';

type ResetFormConfirmationProps = {
    worksheetId: string;
    calculationId: string;
    name: string;
    onClose: () => void;
};

function ResetFormConfirmation({ worksheetId, calculationId, name, onClose }: ResetFormConfirmationProps): JSX.Element {
    const dispatch = useDispatch();
    const resetWorksheetQuery = useResetWorksheetCalculation(worksheetId, calculationId);

    function handleReset(): void {
        resetWorksheetQuery.mutate('', {
            onSuccess: (res) => {
                dispatch(loadSchema({ schema: res.calculation.schema }));
                toastNotification('success', 'Successfully reset the calculation!');
                onClose();
            },
            onError: (res) => {
                toastNotification('error', 'Unable to reset the calculation!', res.response?.data.message);
            },
        });
    }

    return (
        <Dialog
            isOpen={true}
            description="Do you want to reset this calculation? All values and linked entries will be removed and cannot be recovered."
            primaryAction="Reset"
            secondaryAction="Cancel"
            title={`Reset ${name}`}
            type="error"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={handleReset}
            isLoading={resetWorksheetQuery.isLoading}
        />
    );
}
export default ResetFormConfirmation;
